<div
class="col-12 flex flex-column" style="height: 78vh">
    <form [formGroup]="columnsFormGroup" *ngIf="stock">
      <div class="p-fluid formgrid grid formgroup-inline align-items-end pb-2">
        <div class="col-12 md:col-3">
          <label for="stockColumnId" style="font-weight: bold;">
           {{'StockColumnRules.Column' | translate}} *
          </label>
          <p-dropdown
            id="stockColumnId"
            formControlName="stockColumnId"
            appendTo="body"
            [options]="usedColumn"
            [filter]="true"
            optionLabel="columnName"
            filterBy="columnName"
            optionValue="id"
            [showClear]="false"
            [autoDisplayFirst]="false"
            class="custom-dropdown"/>
              <ng-template pTemplate="selectedItem" let-stockColumn>
                <div *ngIf="stockColumn">
                  {{ stockColumn | stockColumnDesc }}
                </div>
              </ng-template>
              <ng-template let-stockColumn pTemplate="item">
                      <div>{{stockColumn | stockColumnDesc}}</div>
              </ng-template>
        </div>

        <div class="col-12 md:col-3">
          <label for="destinationColumnId" style="font-weight: bold;">
           {{'StockColumnRules.DestinationColumn' | translate}}  *
          </label>
          <p-dropdown
            id="destinationColumnId"
            formControlName="destinationColumnId"
            appendTo="body"
            [options]="notUsedColumn"
            [filter]="true"
            optionLabel="columnName"
            filterBy="columnName"
            optionValue="id"
            [showClear]="false"
            [autoDisplayFirst]="false"
            class="custom-dropdown">
              <ng-template pTemplate="selectedItem" let-stockColumn>
                <div *ngIf="stockColumn">
                  {{ stockColumn | stockColumnDesc }}
                </div>
              </ng-template>
              <ng-template let-stockColumn pTemplate="item">
                      <div>{{stockColumn | stockColumnDesc}}</div>
              </ng-template>
          </p-dropdown>
        </div>

        <div class="col-12 md:col-2">
          <h4 class="label-toogle">
            {{'StockColumnRules.ChangeOrigin' | translate}}
          </h4>
              <p-inputSwitch
                id="changeOrigin"
                formControlName="changeOrigin"
                >
              </p-inputSwitch>
        </div>

        <div class="col-12 md:col-2">
          <label for="divisorCharacter" style="font-weight: bold;">
           {{'StockColumnRules.CharacterDivisor' | translate}} *
          </label>
          <input
            type="text"
            id="divisorCharacter"
            formControlName="divisorCharacter"
            placeholder="Carácter"
            [maxlength]="10"
            style="width: 100%;"
            class="custom-input"
          />
        </div>

        <div class="col-12 md:col-2 mt-2 md:mt-0">
          <p-button
            label="{{'CreatePalletStock.AddNewColumn' | translate}}"
            (onClick)="createRules()"
            class="custom-text-button add-button"
            [loading]="loading"
            styleClass="p-button-sm">
          </p-button>
        </div>
      </div>
    </form>

    <div *ngIf="stock" class="grid">
      <div class="col-12 stock-columns-table">
        <p-table
          [value]="rules"
          [scrollable]="true"
          class="custom-table">
          <ng-template  pTemplate="header">
            <tr>
              <th>
                <div class="flex justify-content-center">
                {{'StockColumnRules.Column' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                {{'StockColumnRules.CharacterDivisor' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                {{'StockColumnRules.DestinationColumn' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
              {{'StockColumnRules.ChangeOrigin' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.ActionsColumn' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template  pTemplate="body" let-rule let-index="rowIndex">
            <tr>
              <td>
                <div class="flex justify-content-center">
                    {{ rule.stockColumn  | stockColumnDesc }}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                  {{ rule.divisorCharacter }}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                    {{ rule.destinationColumn  | stockColumnDesc }}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                    <p-checkbox  [binary]="true" [(ngModel)]="rule.changeOrigin" [disabled]="true"></p-checkbox>
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                    <span class="material-symbols-outlined icon"
                    style="color: red;"
                    (click)="removeRule(rule.id)"
                    pTooltip="{{'StockColumnRules.RemoveButton' | translate}}">remove</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div class="col-12 flex justify-content-end">
          <p-button
            label="{{'StockColumnRules.ApplyRules' | translate}}"
            (onClick)="applyRules()"
            class="custom-text-button add-button"
            [loading]="loading"
            styleClass="p-button-sm">
          </p-button>
        </div>
      </div>
    </div>
</div>

